import "./tablaGenerica.css";
import React, { useState, useMemo } from "react";
import Paginacion from "../tablas/paginacion.js"; // ajusta la ruta

export default function TablaGenerica({
  titulo,
  headers = [],
  data = [], // pasamos los datos completos
  rowsPerPage = 10,
  renderRow,
  footer,
  className = ""   // 👈 nuevo
}) {
  const [paginaActual, setPaginaActual] = useState(1);

  // 🔹 total páginas
  const totalPaginas = Math.max(1, Math.ceil(data.length / rowsPerPage));

  // 🔹 datos de la página actual
  const datosPaginados = useMemo(() => {
    const inicio = (paginaActual - 1) * rowsPerPage;
    return data.slice(inicio, inicio + rowsPerPage);
  }, [data, paginaActual, rowsPerPage]);

  // 🔹 cambiar página
  const cambiarPagina = (numero) => {
    if (numero >= 1 && numero <= totalPaginas) {
      setPaginaActual(numero);
    }
  };

  // 🔹 rellenar filas vacías si hay menos de rowsPerPage
  const filasCompletas = [
    ...datosPaginados,
    ...Array.from({ length: rowsPerPage - datosPaginados.length }),
  ];
return (
    <div className={`tabla-container ${className}`}>
      {titulo && (
        <div className="tabla-info">
          <span>{titulo}</span>
        </div>
      )}

      <div className="tabla-scroll">
        <table className={`tabla-datos ${className}`}>
          <colgroup>
            {headers.map((_, i) => (
              <col key={i} className={`col-${i + 1}`} />
            ))}
          </colgroup>

          <thead>
            <tr>
              {headers.map((h, i) => (
                <th key={i} className={`col-${i + 1}`}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {filasCompletas.map((item, i) =>
              item ? (
                renderRow(item)
              ) : (
                <tr key={`vacio-${i}`}>
                  {headers.map((_, j) => (
                    <td key={j} className={`col-${j + 1}`}>
                      &nbsp;
                    </td>
                  ))}
                </tr>
              ),
            )}
          </tbody>
                    {footer && <tfoot>{footer()}</tfoot>}

        </table>
      </div>

      {/* 🔹 paginación dentro de la tabla */}
      {totalPaginas > 1 && (
        <div className="tabla-paginacion">
          <Paginacion
            paginaActual={paginaActual}
            totalPaginas={totalPaginas}
            onCambiarPagina={cambiarPagina}
          />
        </div>
      )}
    </div>
  );
}
